import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import Container from './Container';
import CardsGrid from './CardsGrid';
import Grid from './Grid';
import Card from './Card';
import { sendEvent } from '../utils/analytics';
import IconRotate from '../public/images/rotate.svg';
import IconUnlock from '../public/images/unlock.svg';
import IconSplit from '../public/images/split.svg';
import IconCompress from '../public/images/compress.svg';
import IconWord from '../public/images/word.svg';
import IconExcel from '../public/images/excel.svg';
import IconJpg from '../public/images/jpg.svg';
import IconPng from '../public/images/png.svg';
import IconPpt from '../public/images/ppt.svg';
import IconHtml from '../public/images/html.svg';

const ActionsGrid = ({
  title,
  edit,
  rotate,
  unlock,
  split,
  compress,
  pdf2word,
  pdf2excel,
  pdf2jpg,
  pdf2png,
  pdf2ppt,
  jpg2pdf,
  word2pdf,
  excel2pdf,
  html2pdf,
  className,
}) => {
  const { t } = useTranslation();

  const handleCardClick = useCallback((event, { href }) => {
    sendEvent({
      category: 'related',
      action: 'card-click',
      label: href,
    });
  }, []);

  return (
    <Container className={`my-xs-3 my-md-4 ${className ? className : ''}`}>
      <h3>
        {title}
      </h3>
      <CardsGrid>
        {rotate && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/rotate-pdf"
              title={t('common:cards.rotate.title')}
              text={t('common:cards.rotate.text')}
              icon={IconRotate}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {false && unlock && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/unlock-pdf"
              title={t('common:cards.unlock.title')}
              text={t('common:cards.unlock.text')}
              icon={IconUnlock}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {split && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/split-pdf"
              title={t('common:cards.split.title')}
              text={t('common:cards.split.text')}
              icon={IconSplit}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {compress && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/compress-pdf"
              title={t('common:cards.compress.title')}
              text={t('common:cards.compress.text')}
              icon={IconCompress}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {pdf2word && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/pdf-to-word"
              title={t('common:cards.pdf-to-word.title')}
              text={t('common:cards.pdf-to-word.text')}
              icon={IconWord}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {pdf2excel && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/pdf-to-excel"
              title={t('common:cards.pdf-to-excel.title')}
              text={t('common:cards.pdf-to-excel.text')}
              icon={IconExcel}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {pdf2jpg && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/pdf-to-jpg"
              title={t('common:cards.pdf-to-jpg.title')}
              text={t('common:cards.pdf-to-jpg.text')}
              icon={IconJpg}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {pdf2png && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/pdf-to-png"
              title={t('common:cards.pdf-to-png.title')}
              text={t('common:cards.pdf-to-png.text')}
              icon={IconPng}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {pdf2ppt && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/pdf-to-ppt"
              title={t('common:cards.pdf-to-ppt.title')}
              text={t('common:cards.pdf-to-ppt.text')}
              icon={IconPpt}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {jpg2pdf && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/jpg-to-pdf"
              title={t('common:cards.jpg-to-pdf.title')}
              text={t('common:cards.jpg-to-pdf.text')}
              icon={IconJpg}
              onClick={handleCardClick}
            />
            </Grid.Item>
        )}
        {word2pdf && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/word-to-pdf"
              title={t('common:cards.word-to-pdf.title')}
              text={t('common:cards.word-to-pdf.text')}
              icon={IconWord}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {excel2pdf && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/excel-to-pdf"
              title={t('common:cards.excel-to-pdf.title')}
              text={t('common:cards.excel-to-pdf.text')}
              icon={IconExcel}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
        {html2pdf && (
          <Grid.Item>
            <Card
              asLink={false}
              href="/html-to-pdf"
              title={t('common:cards.html-to-pdf.title')}
              text={t('common:cards.html-to-pdf.text')}
              icon={IconHtml}
              onClick={handleCardClick}
            />
          </Grid.Item>
        )}
      </CardsGrid>
    </Container>
  );
};

ActionsGrid.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  rotate: PropTypes.bool,
  unlock: PropTypes.bool,
  merge: PropTypes.bool,
  split: PropTypes.bool,
  compress: PropTypes.bool,
  pdf2word: PropTypes.bool,
  pdf2excel: PropTypes.bool,
  pdf2jpg: PropTypes.bool,
  pdf2png: PropTypes.bool,
  pdf2ppt: PropTypes.bool,
  jpg2pdf: PropTypes.bool,
  word2pdf: PropTypes.bool,
  excel2pdf: PropTypes.bool,
  html2pdf: PropTypes.bool,
  className: PropTypes.string,
};

export default ActionsGrid;
